import { AxiosResponse } from "axios";
import { KeyValue } from "@/main/models/common";
import { Result } from "@/main/models/common/resultResponse";
import { RequestFormatRequest } from "@/main/models/request/RequestFormatRequest";

export abstract class IRequestFormatApi {
	abstract getDomain(request: RequestFormatRequest): Promise<AxiosResponse<Result<KeyValue[]>>>;
}
